module.exports = __webpack_public_path__ + "img/edit-grey.222ce9fb.svg";